export const RU_LOCALE = 'ru';
export const EN_LOCALE = 'en';
export const SUPPORTED_LOCALES = [EN_LOCALE, RU_LOCALE];

export const getMessages = async (locale: typeof SUPPORTED_LOCALES[number]) => {
    const messages = await import(`../messages/${locale}/index.ts`);

    return { ...messages };
};
